import { Instance } from 'mobx-state-tree';
import { NotificationTypeSettingsDtoModelBase } from './NotificationTypeSettingsDtoModel.base';

/* The TypeScript type of an instance of NotificationTypeSettingsDtoModel */
export interface NotificationTypeSettingsDtoModelType extends Instance<typeof NotificationTypeSettingsDtoModel.Type> {}

/* A graphql query fragment builders for NotificationTypeSettingsDtoModel */
export { selectFromNotificationTypeSettingsDto, notificationTypeSettingsDtoModelPrimitives, NotificationTypeSettingsDtoModelSelector } from './NotificationTypeSettingsDtoModel.base';

/**
 * NotificationTypeSettingsDtoModel
 */
export const NotificationTypeSettingsDtoModel = NotificationTypeSettingsDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
